module.exports = __webpack_public_path__ + "img/34.52098a5c.jpg";